/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { Mintbody } from '../types';
import { notifications } from '@mantine/notifications';
// I18n
import { useTranslation } from 'react-i18next';

export const mint = (
	data: Mintbody
): Promise<{
	user: any;
}> => {
	return apiClient.post('/aco2_tokens', {
		...data,
	});
};

export const useMint = (page: number, size: number) => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: mint,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [
					'productions',
					{ page: page, size: size },
				],
			});
			notifications.show({
				title: t('global.success'),
				message: t(
					'productions.notifications.productionSuccessfullyMinted'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: ['mint-histories'],
			});
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
